var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { forwardIconRef } from "../../lib/icons";
var ArrowIcon = forwardIconRef(function (_a, ref) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ ref: ref, xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, props),
        React.createElement("path", { fill: "none", d: "M0 0h20v20H0z" }),
        React.createElement("path", { fill: color, d: "M3 6.833a.831.831 0 00.244.589l6.667 6.666a.833.833 0 001.178 0l6.667-6.666a.83332542.83332542 0 00-1.179-1.178L10.5 12.321 4.422 6.244A.833.833 0 003 6.833" })));
});
export default ArrowIcon;
